module.exports = __webpack_public_path__ + "static/media/bfile-life-stage-4.b836f551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bfile-life-stage-4.png
// module id = 2669
// module chunks = 0